module.exports = __webpack_public_path__ + "img/qcode.e584cf4c.jpg";